package app.nestbridge.app.context.identity

import app.nestbridge.domain.identity.model.ProfessionalProfile
import app.nestbridge.domain.identity.model.User
import app.nestbridge.domain.identity.model.UserProfile

data class UserContext(
    val user: User,
    val userProfile: UserProfile? = null,
    val professionalProfile: ProfessionalProfile? = null,
)
